import { LOCALES, KEYS } from '../constants';

const csCZTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_CZECH_CZ] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE]: "Role partnera",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR]: "Integrátor",
    [KEYS.L18N_KEY_LABEL_PROVIDER]: "Poskytovatel",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]: "Úroveň partnera",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION]: "Specializace partnera",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE]: "Služba Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME]: "Název partnera",
    [KEYS.L18N_KEY_LABEL_LOCATION]: "Poloha",
    [KEYS.L18N_KEY_LABEL_COUNTRY]: "Země",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD]: "Klíčové slovo názvu partnera",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_]: "Klíčová slova názvu partnera",
    [KEYS.L18N_KEY_LABEL_SORTING]: "Řazení",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS]: "Specializace",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS]: "Specializace partnera",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES]: "Úroveň poskytovatele a služby Cisco Powered",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER]: "poskytovatel zlaté úrovně",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER]: "poskytovatel prémiové úrovně",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER]: "vyberte poskytovatele",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]: "Získat pokyny",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE]: "Vyžádání cenové nabídky",
    [KEYS.L18N_KEY_LABEL_OPEN]: "Otevřít",
    [KEYS.L18N_KEY_LABEL_EXPAND]: "Rozbalit",
    [KEYS.L18N_KEY_LABEL_COLLAPSE]: "Sbalit",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY]: "Vybrat zemi/oblast",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE]: "Zvolit roli",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_]: "Zvolte specializace",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_]: "Zvolte služby Cisco Powered",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]: "Zvolit specializace",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_]: "Zvolit úrovně",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY]: "Země/oblast partnera",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS]: "Úrovně integrátora",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS]: "Úrovně poskytovatele",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS]: "Specializace integrátora",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES]: "Služby Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES]: "Názvy partnera",
    [KEYS.L18N_KEY_LABEL_BACK]: "Zpět",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]: "Všechny výsledky",
    [KEYS.L18N_KEY_LABEL_ALL]: "Vše ",
    [KEYS.L18N_KEY_LABEL_SAVED]: "Uložené",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS]: "Moji partneři",
    [KEYS.L18N_KEY_LABEL_ADD]: "Přidat",
    [KEYS.L18N_KEY_LABEL_REMOVE]: "Odstranit",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE]: "Přidat do porovnání ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE]: "Vyberte alespoň jednu další možnost",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED]: "Porovnat vybrané ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR]: "Odebrat ze srovnávače",
    [KEYS.L18N_KEY_LABEL_COMPARE]: "Porovnat",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]: "Úroveň partnera",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]: "Probíhá zpracování",
    [KEYS.L18N_KEY_LABEL_RESULT]: "výsledek",
    [KEYS.L18N_KEY_LABEL_RESULTS]: "výsledků",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS]: "Žádné výsledky",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]: "výsledek v ",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]: "výsledků v",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]: "Žádné výsledky v",
    [KEYS.L18N_KEY_LABEL_PREVIOUS]: "Předchozí",
    [KEYS.L18N_KEY_LABEL_PREV]: "Předch.",
    [KEYS.L18N_KEY_LABEL_NEXT]: "Další",
    [KEYS.L18N_KEY_LABEL_SAVE]: "Uložit",
    [KEYS.L18N_KEY_LABEL_EXPERTISE]: "Odbornost",
    [KEYS.L18N_KEY_LABEL_OVERVIEW]: "Přehled",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO]: "spadá pod společnost Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]: "Integrátoři vytvářejí koncová řešení pro naše zákazníky. Primárně provádějí transakce prodejem, ale také přinášejí své unikátní znalosti a jejich pomocí řeší problémy zákazníků.",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION]: "Poskytovatelé jsou odborníci na doručování spravovaných a cloudových řešení. Zákazníci vyhledávají větší flexibilitu, co se týká používání řešení, a poskytovatelé mají na trhu čím dál tím důležitější postavení.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES]: "Minulá vyhledávání",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH]: "Minulé vyhledávání",
    [KEYS.L18N_KEY_LABEL_ROLES]: "Role ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY]: "Technologie",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES]: "Odvětví",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS]: "Integrátoři",
    [KEYS.L18N_KEY_LABEL_PROVIDERS]: "Poskytovatelé",
    [KEYS.L18N_KEY_LABEL_OTHER]: "další",
    [KEYS.L18N_KEY_LABEL_OTHERS]: "Další",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]: "Nebyli nalezeni žádní další uložení partneři",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS]: "Nebyli nalezeni žádní uložení integrátoři",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS]: "Nebyli nalezeni žádní uložení poskytovatelé",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]: "filtrovat podle potřeby",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA]: "vyhledat podle kombinovaných kritérií",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION]: "vyhledat podle umístění",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]: "Po celém světě působí 1 partner",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]: "Existují",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]: "partneři, kteří působí po celém světě",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]: "Nepůsobí žádní partneři",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]: "Nalezli jsme 1 partnera, který působí v",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]: "partneři, kteří působí v",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]: "Nenalezli jsme žádné partnery, kteří působí v",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]: "Změna pobočky",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]: "Filtrovat podle potřeby",
    [KEYS.L18N_KEY_LABEL_SEARCH]: "Vyhledat",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]: "podle jména/názvu, úrovně a specializace",
    [KEYS.L18N_KEY_LABEL_SELECTED]: "vybráno",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]: "Nebyly nalezeny žádné shody",
    [KEYS.L18N_KEY_LABEL_RANK_UP]: "Hodnocení vzestupně",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]: "Hodnocení sestupně",
    [KEYS.L18N_KEY_LABEL_NAME_UP]: "Názvy vzestupně",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]: "Názvy sestupně",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]: "Je nutné se přihlásit",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]: "K provedení této akce musíte být přihlášeni.",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]: "Obnovení vyhledávání se nezdařilo",
    [KEYS.L18N_KEY_LABEL_LOG_IN]: "Přihlásit",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]: "Partner byl úspěšně uložen.",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]: "Partner nemohl být uložen.",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]: "Partner byl úspěšně odebrán.",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]: "Partnera se nepodařilo odstranit.",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]: "Chcete-li hledat podle jména/názvu, úrovně nebo specializace, zadejte klíčové slovo",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]: "Vývojáři jsou odborníci, kteří vytvářejí přizpůsobená softwarová a hardwarová řešení na základě technologií společnosti Cisco. Výsledkem jsou jedinečná řešení, která propojují systémy a zajišťují výsledky.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]: "Poradci jsou odborníci s hlubokými znalostmi daného odvětví, kteří vedou firmy na jejich cestě k objevování řešení komplexních obchodních výzev.",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]: "Odlišný partner",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]: "Abecedně",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]: "Nejvíce znalostí",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]: "Vývojář",
    [KEYS.L18N_KEY_LABEL_ADVISOR]: "Poradce",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filtry",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filtr",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Specializace partnera",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Zamítnout",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Specializace",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Odbornost",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Nebyl uveden žádný popis.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Informace o produktu",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Vymazat srovnávač",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"Srovnání partnerů",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Role",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Technologické zaměření",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Popis",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Výběr jazyka",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Odhlásit",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Inkluzivní partner",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "O společnosti Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Kontaktujte nás",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Kariéra",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Seznamte se s našimi partnery",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Zpětná vazba",
    [KEYS.L18N_KEY_LABEL_HELP]: "Nápověda",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Smluvní podmínky",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Prohlášení o ochraně osobních údajů",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Ochranné známky",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparentnost dodavatelského řetězce",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Sitemap",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "O společnosti Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Kontaktujte nás",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Kariéra",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Seznamte se s našimi partnery",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Zpětná vazba",
    [KEYS.L18N_KEY_LABEL_HELP]: "Nápověda",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Smluvní podmínky",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Prohlášení o ochraně osobních údajů",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Ochranné známky",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparentnost dodavatelského řetězce",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Sitemap",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Jak nakupovat",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Partneři",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Produkty a služby",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Řešení",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Podpora",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Učit se",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Prozkoumat Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Nabídka",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Zavřít",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Zobrazit více",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Zobrazit méně",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Nemáte účet?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "zaregistrovat se"
  }
});

export default csCZTranslations;
